import type { FaireProductEntity } from "../../entity_types/product";

export const p_nmskry2w23: FaireProductEntity = {
  token: "p_nmskry2w23",
  type: "product",
  name: "Gold Mama Necklace - Mother's Day Gift",
  brandToken: "b_j58tygnzmp",
  brandName: "Solemare",
  imageUrl:
    "https://cdn.faire.com/fastly/6a1909f5de269ae5fda2ed9a02b9b9ea7204e1bc85667aa0c75873a672d855ca.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ea5e2b442fe1b9954eaf3a55cb6864e554504778af211c3d07d2f861a041949d.jpeg",
    "https://cdn.faire.com/fastly/2b43250f9d16b8d24bc254698b3a67f50af292affead11c8d4b031ff6fbdbdc0.png",
  ],
  priceDollars: 30.13,
  description:
    "Mama necklace with dangling letters and cz stones. Minimalist and delicate design.\n\nWhy your customers will love it:\n\n🧿 perfect for layering\n🧿 gift for new mom\n🧿 trendy and minimalist \n\n* sterling silver 925 stamped\n\n* dainty mama necklace\n\n* length 16 inches\n\n* made in Turkey\n\n* ships from California ",
  tags: [],
  msrpDollars: 60.27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:47.739Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
